import { getCompanyUsers } from 'adminPanel/api/companies';
import { User } from 'adminPanel/types';
import { useEffect, useState } from 'react';

export const useCompanyUsers = (companyId: number) => {
    const [users, setUsers] = useState<User[]>([]);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        getCompanyUsers(companyId)
            .then(setUsers)
            .finally(() => {
                setIsLoading(false);
            });
    }, [companyId]);

    return { users, isLoading };
};
